import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { SectionHeadline } from '@/components/SectionHeadline'
import {
  Card,
  CardContent,
  CardContentDecoration,
  CardContentFooterActions,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'
import { Avatar } from '@/components/Avatar'
import { StyledLink } from '@/components/Link'
import { externalLinks } from '@/utils/link'

export interface RelationManagerInfoSectionProps {
  testId?: string
  fullName: string
  avatarUrl?: string | null
  callLink?: string | null
  isJobClosed?: boolean
}

export function RelationManagerSection({
  fullName,
  testId,
  avatarUrl,
  callLink,
  isJobClosed,
}: RelationManagerInfoSectionProps) {
  const helpLink = isJobClosed ? (
    <StyledLink target="_blank" href={externalLinks.contactSupport()}>
      Contact us
    </StyledLink>
  ) : callLink ? (
    <StyledLink target="_blank" href={callLink}>
      Schedule a call
    </StyledLink>
  ) : null

  return (
    <PageSection testId={testId}>
      <SectionHeadline>Your Relationship Manager</SectionHeadline>
      <Card>
        <CardContent>
          <CardContentDecoration>
            <Avatar subject={{ displayName: fullName, avatarUrl }} />
          </CardContentDecoration>
          <CardTitle>{fullName}</CardTitle>
          {helpLink && (
            <>
              <CardSubtitle>Need help or have an issue?</CardSubtitle>
              <CardContentFooterActions>{helpLink}</CardContentFooterActions>
            </>
          )}
        </CardContent>
      </Card>
    </PageSection>
  )
}
